import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
   
title:{
    display: "flex",
    justifyContent: "left",
    fontWeight: "bold",

    
    padding:3,
    [theme.breakpoints.between("xs", "sm")]: {
      fontSize:13
      },
}
}));
